@if (esMedia() == true) {
  @switch (estadoMedia()) {
    @case (EMicaChat_EstadoMensajeMedia.DESCARGANDO) {
      <div
        class="flex items-center gap-2 max-w-[75%] rounded-2xl px-3 py-2 bg-gray-100 border border-gray-200"
      >
        <div class="flex items-center justify-center w-9 h-9 rounded-full bg-white shadow-sm">
          <div
            class="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"
          ></div>
        </div>

        <div class="flex flex-col flex-1">
          <span class="text-sm text-gray-800 leading-tight">
            Descargando {{ tipoMediaNombre() | lowercase }}...
          </span>

          <div class="mt-1 h-1.5 w-full bg-gray-300 rounded-full overflow-hidden">
            <div
              class="h-full bg-gray-500 rounded-full animate-[pulse_1.2s_ease-in-out_infinite] w-1/2"
            ></div>
          </div>
        </div>
      </div>
    }
    @case (EMicaChat_EstadoMensajeMedia.ERROR_DESCARGA) {
      <div class="flex items-center gap-2 rounded-lg bg-red-50 px-4 py-3 border border-red-200">
        <i class="bi bi-exclamation-triangle-fill text-red-500 text-lg"></i>
        <span class="text-sm font-medium text-red-700"
          >Error al descargar {{ tipoMediaNombre() | lowercase }}</span
        >
      </div>
    }
    @case (EMicaChat_EstadoMensajeMedia.DESCARGADO) {
      @switch (mensaje().tipo) {
        @case (EMicaChat_TipoMensaje.AUDIO) {
          @let dataAudio = getAudioData(mensaje());
          @if (dataAudio) {
            <app-mica-chat-mensaje-audio [audio]="dataAudio" />
          }
        }
        @case (EMicaChat_TipoMensaje.IMAGE) {
          @let mediaData = getMediaData();
          @if (mediaData) {
            <app-mica-chat-mensaje-imagen
              [streamUrl]="mediaData.stream_url"
              [caption]="mediaData.caption"
            />
          }
        }
        @case (EMicaChat_TipoMensaje.VIDEO) {
          @let mediaData = getMediaData();
          @if (mediaData) {
            <app-mica-chat-mensaje-video
              [streamUrl]="mediaData.stream_url"
              [caption]="mediaData.caption"
            />
          }
        }
        @case (EMicaChat_TipoMensaje.DOCUMENT) {
          @let mediaData = getMediaData();
          @if (mediaData) {
            <app-mica-chat-mensaje-documento
              [streamUrl]="mediaData.stream_url"
              [fileName]="mediaData.file_name"
            />
          }
        }
      }
    }
    @default {
      <div class="flex items-center gap-2 rounded-lg bg-amber-50 px-4 py-3 border border-amber-200">
        <i class="bi bi-hourglass-split animate-spin text-amber-600 text-lg"></i>
        <span class="text-sm font-medium text-amber-700"
          >Procesando {{ tipoMediaNombre() | lowercase }}...</span
        >
      </div>
    }
  }
}
